import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Ribbon } from '@udemy/react-messaging-components';
export function SpecialBundlePriceBadge() {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(Ribbon, {
    size: "large",
    color: "green-150"
  }, gettext('Special Bundle Price'));
}
//# sourceMappingURL=special-bundle-price-badge.react-component.js.map